import { makeStyles } from 'tss-react/mui';

const useCombinationLineStyles = makeStyles()(() => ({
  root: {
    padding: '2px 0px',
  },
}));

export default useCombinationLineStyles;
